module.exports = __webpack_public_path__ + "static/media/Plano_de_Asientos.b1d16c4c.docx";